import React from 'react';

import { IconProps } from './types';

/**
 * Butt caps and miter joins, matching `GlobeIcon` rather than the round caps
 * the other 26px icons use. The two latitude lines are chords that overhang the
 * sphere by about half a pixel by design; a round cap adds half the stroke
 * width to each of their four ends, which turns that flush meeting into a
 * rounded nub poking out of the circle.
 */
export const CellGlobeIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M22.75 13C22.75 18.3828 18.3828 22.75 13 22.75C7.6172 22.75 3.25 18.3828 3.25 13C3.25 7.6172 7.6172 3.25 13 3.25C18.3828 3.25 22.75 7.6172 22.75 13Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="1.75"
        />
        <path
          d="M17.3336 13C17.3336 18.3828 15.3926 22.75 13.0002 22.75C10.6079 22.75 8.6669 18.3828 8.6669 13C8.6669 7.6172 10.6079 3.25 13.0002 3.25C15.3926 3.25 17.3336 7.6172 17.3336 13Z"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="1.75"
        />
        <path
          d="M3.25 9.75H22.75"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="1.75"
        />
        <path
          d="M3.25 16.25H22.75"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
